import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// 라우트 변경 시 hash가 있으면 해당 엘리먼트로 부드러운 스크롤,
// 없으면 화면 최상단으로 즉시 스크롤.
// key는 동일 URL 재클릭 시에도 useEffect 재실행을 보장 (예: /#pricing 반복 클릭).
export default function ScrollToTop() {
  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        // 다음 tick — 페이지 마운트 후 스크롤
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 0);
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash, key]);
  return null;
}
